module.exports = __webpack_public_path__ + "static/media/Low-Power Performance.78cc1757.png";